.modal {
  position: fixed;
  inset: 0;
  margin: auto;

  width: min(720px, calc(100vw - 36px));
  max-width: none;
  max-height: min(90dvh, 880px);
  padding: 0;
  border: 1px solid color-mix(in srgb, var(--color-border) 80%, transparent);
  border-radius: var(--radius-xl);
  background-color: var(--color-surface);
  color: var(--color-text);
  box-shadow: 0 32px 90px rgb(20 13 25 / 28%);
  overflow: hidden;
}

.modal[open] {
  display: flex;
  flex-direction: column;
  animation: modal-in var(--duration-base) var(--ease-out);
}

.modal::backdrop {
  background-color: rgb(30 23 34 / 58%);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  animation: modal-backdrop-in var(--duration-fast) var(--ease-standard);
}

.sm {
  width: min(470px, calc(100vw - 36px));
}

.lg {
  width: min(980px, calc(100vw - 36px));
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 20px 14px;
  border-bottom: 1px solid var(--color-border);
}

.noDivider {
  border-bottom: none;
}

.title {
  margin: 0;
  font-size: var(--text-lg);
  font-weight: var(--weight-bold);
  letter-spacing: -0.02em;
}

.subtitle {
  margin: 5px 0 0;
  font-size: var(--text-2xs);
  color: var(--color-text-muted);
}

.close {
  flex: none;
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: var(--radius-sm);
  background-color: var(--color-bg-subtle);
  color: var(--color-text-muted);
  cursor: pointer;
  transition:
    background-color var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard);
}

.close:hover {
  background-color: var(--color-border);
  color: var(--color-text);
}

.close svg {
  width: 17px;
  height: 17px;
}

.body {
  padding: 18px 20px;
  overflow: auto;
  overscroll-behavior: contain;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-2);
  padding: 13px 20px calc(13px + var(--safe-bottom));
  border-top: 1px solid var(--color-border);
  background-color: var(--color-surface-sunken);
}

@keyframes modal-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
  }
}

@keyframes modal-backdrop-in {
  from {
    opacity: 0;
  }
}

@media (max-width: 560px) {
  .modal,
  .sm,
  .lg {
    width: 100%;
    max-width: none;
    max-height: 95dvh;
    /* Sits on the bottom edge as a sheet on a phone. */
    margin: auto 0 0;
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  }

  .header {
    padding: 13px 14px 10px;
  }

  .body {
    padding: 12px 14px;
  }

  .footer {
    padding: 9px 12px calc(9px + var(--safe-bottom));
  }

  .footer > * {
    flex: 1;
  }
}
